import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { IGroupSpaceResource } from "../types";

export type IGroupSpaceStartMutationParameters = {
    groupSpace: RelationalValue<IGroupSpaceResource>;
};

export type IGroupSpaceStartMutationResult = IGroupSpaceResource;

export const groupSpaceStartMutation: IApiMutationFunction<IGroupSpaceStartMutationParameters> = ({ groupSpace }) => ({
    method: "PUT",
    url: `/group_spaces/${mapRelationalValue(groupSpace)}/start`,
    data: {},
});

export const useGroupSpaceStartMutation = createApiMutationHook<
    IGroupSpaceStartMutationParameters,
    IGroupSpaceStartMutationResult
>(groupSpaceStartMutation);
